/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "EmailCustomerInvite",
            "endpoint": "https://8hpj78bsw6.execute-api.eu-west-2.amazonaws.com/develop",
            "region": "eu-west-2"
        },
        {
            "name": "NextOrderNumber",
            "endpoint": "https://jnhfvy2769.execute-api.eu-west-2.amazonaws.com/develop",
            "region": "eu-west-2"
        },
        {
            "name": "SesTemplateEmailer",
            "endpoint": "https://227t4ern4g.execute-api.eu-west-2.amazonaws.com/develop",
            "region": "eu-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://4kbnta4kovhildawdwcef6fmty.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-o4hem32ikjcvddgutejfpdd3le",
    "aws_cognito_identity_pool_id": "eu-west-2:a8448ccb-8dc8-4c6b-a0f2-17a903b8b348",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_Q8nPD43mK",
    "aws_user_pools_web_client_id": "3uhts40e97gcfqpe8uga3l9ccg",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "cwsstorage66e22-develop",
    "aws_user_files_s3_bucket_region": "eu-west-2",
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "NextOrderNumber-develop",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
